import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PublicDiagramPage from 'modules/Diagrams/pages/PublicDiagramPage';

// Routes for publicly shared diagrams. Mounted by _app.jsx when the URL
// matches /public/diagrams/* — completely outside the SignedIn auth gate.
const PublicDiagramRoutes = () => (
  <Switch>
    <Route
      path="/public/diagrams/:id"
      exact
      component={PublicDiagramPage}
    />
  </Switch>
);

export default PublicDiagramRoutes;
